// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.side-nav[data-v-22ba47ca] {\n    position: fixed;\n\tdisplay: flex;\n    flex-direction: column;\n\talign-items: left;\n\n    top: 30%;\n    left: 80px;\n\tmin-height: 50px;\n\tfont-weight: 500;\n\tz-index: 9;\n}\na[data-v-22ba47ca] {\n    padding: 5px;\n}\n.router-link-exact-active[data-v-22ba47ca] {\n    color: var(--purple);\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
